export default __webpack_public_path__ + "static/media/Icon.2e52a2ab.png";